/**
 * @description Module document
 */

/* global ModuloTS */

(() => {
	// VARS
	const root = document.querySelector('.content-404');

	// EVENTS
	const createButtonArea = (input, areaName, icon) => {
		if (root.querySelector(`${input}`)) {
			root.querySelector(`${input}`).placeholder =
				ModuloTS['I search'] + '...';
		}
	};

	const page = () => {
		document
			.querySelector('.content-404 .button')
			.classList.remove('form-control', 'form-control-lg');
		document
			.querySelector('.content-404 .button')
			.classList.add('btn', 'btn-primary');
		document.querySelector('.breadcrumbs-block').remove();
		document.querySelector('#block-spe-banner').remove();
	};
	// GO 🚀
	const init = () => {
		if (root) {
			page();
			createButtonArea(
				'.form-autocomplete',
				'content-404__search',
				'search'
			);
		}
	};

	init();
})();
